import '@babel/polyfill'
import axios from 'axios'

if (typeof ShopifyAPI === 'undefined') {
  var ShopifyAPI = {}
}

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  return axios
    .get('/cart.js')
    .then(response => {
      return callback(response.data.items, response.data.total_price)
    })
    .catch(function(error) {
      console.log(error)
    })
}

// Post to cart/change.js to update cart
ShopifyAPI.changeItem = function(callback, quantity, linePos) {
  linePos++

  return axios
    .post('/cart/change.js', { quantity: quantity, line: linePos })
    .then(response => {
      return callback(response.data.items, response.data.total_price)
    })
    .catch(function(error) {
      console.log(error)
    })
}

// Post to cart/change.js to update cart
ShopifyAPI.updateItem = function(callback, id, quantity) {
  return axios
    .post('/cart/update.js', { updates: { [id]: quantity } })
    .then(response => {
      return callback(response.data.items, response.data.total_price)
    })
    .catch(function(error) {
      console.log('falied to update cart because', error)
    })
}

ShopifyAPI.getProduct = function(handle) {
  return axios
    .get('/products/' + handle + '.js')
    .then(response => {
      return response.data
    })
    .catch(function(error) {
      return {
        available: false,
      }
    })
}

ShopifyAPI.addCart = function(callback, payload, subTotal) {
  return axios
    .post('/cart/add.js', payload)
    .then(response => {
      return loadCart()
    })
    .catch(function(error) {
      console.log('add to cart failed', error)
    })
}

/*============================================================================
  This function hydrates the cart after the AJAX request has been performed
==============================================================================*/
var hydrateCart = (cartItems, total_price) => {
  let results = []
  let handles = []

  for (let i = 0; i < cartItems.length; i++) {
    let result = {}

    result.id = cartItems[i].id
    result.variantID = cartItems[i].variant_id
    result.title = cartItems[i].product_title
    result.variantOptions = cartItems[i].variant_options
    result.qty = cartItems[i].quantity
    result.linePrice = cartItems[i].line_price
    result.image = cartItems[i].image
    result.url = cartItems[i].url
    result.qty = cartItems[i].quantity
    result.properties = cartItems[i].properties

    results.push(result)
  }

  results.push({ total_price: total_price })

  return results
}

var changeCartContent = function(quantity, linePos) {
  return ShopifyAPI.changeItem(hydrateCart, quantity, linePos).then(response => {
    return response
  })
}

var updateCartContent = function(id, quantity) {
  return ShopifyAPI.updateItem(hydrateCart, id, quantity).then(response => {
    return response
  })
}

var loadCart = function() {
  return ShopifyAPI.getCart(hydrateCart).then(response => {
    return response
  })
}

var getProducts = function(handles) {
  let promises = []

  for (let i = 0; i < handles.length; i++) {
    promises.push(ShopifyAPI.getProduct(handles[i]))
  }

  return Promise.all(promises).then(response => {
    return response
  })
}

var addToCart = function(payload, subTotal) {
  return ShopifyAPI.addCart(hydrateCart, payload, subTotal).then(response => {
    return response
  })
}

export default {
  loadCart,
  hydrateCart,
  changeCartContent,
  updateCartContent,
  getProducts,
  addToCart,
}
